import { Flex } from "grid-styled";
import PropTypes from "prop-types";
import { themeGet } from "styled-system";
import system from "system-components";

const MenuButton = system(
  {
    is: "button",
    bg: "transparent",
    border: "0",
    color: "secondary.0",
    fontFamily: "font",
    fontSize: 2,
    tabIndex: "0"
  },
  "space",
  "display",
  "alignItems",
  "width",
  "height"
).extend`
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  &:active {
    text-decoration: underline;
  }

  &:focus {
    outline: none;
  }
`;

MenuButton.displayName = "MenuButton";

const FocusHolder = system({
  is: Flex,
  display: "inline-flex",
  alignItems: "center",
  tabIndex: "-1",
  height: "100%"
}).extend`
  &:focus {
    outline: 0;
  }
`;

const FocusBorder = system({
  is: Flex,
  alignItems: "center",
  border: "dashed 1px",
  borderColor: "transparent",
  borderRadius: 1,
  p: 1
}).extend`
  &:focus {
    outline: 0;
  }
  ${MenuButton}:focus & {
    border: dashed 1px;
    border-color: ${themeGet("colors.nav.25")};
  }
`;

const FocusMenuButton = props => {
  const keyboardHandler = event => {
    if (event.key === "Enter" || event.key === " ") {
      if (props.onActivation) {
        event.preventDefault();
        props.onActivation();
      }
    }
  };

  let extra = {};
  if (props.onActivation) {
    // If the component has an `onClick` prop
    // Found's Link  will call that function and
    // even deffer to the default browser behaviour.
    // It will end up refreshing the page.
    extra.onClick = props.onActivation;
  }
  return (
    <MenuButton {...props} {...extra} height="100%" onKeyDown={keyboardHandler}>
      <FocusHolder>
        <FocusBorder>{props.children}</FocusBorder>
      </FocusHolder>
    </MenuButton>
  );
};

FocusMenuButton.propTypes = {
  onActivation: PropTypes.func
};

export default FocusMenuButton;
